<template>
  <div class="contact-page">
    <section class="banner">
      <h1>联系我们</h1>
      <p>您可以通过以下方式与九恒取得联系</p>
    </section>
    <div class="ctn">
      <ul>
        <li>
          <h3>联系电话</h3>
          <h4>周一至周五 9:00-18:00</h4>
          <h6>总机<a href="tel:00861050856300">（+86）010-50856300</a></h6>
          <h5>业务咨询 <a href="tel:4001199655">400-1199-655</a></h5>
        </li>
        <li>
          <h3>九恒邮箱</h3>
          <h4>收到邮后24小时内回复</h4>
          <h5><a href="mailto:service@jzfyjt.com">service@jzfyjt.com</a></h5>
        </li>
        <li>
          <h3>九恒地址</h3>
          <h4>北京市经济技术开发区双羊路1号</h4>
          <h5><a :href="url" target="_blank">去这里</a></h5>
        </li>
        <li>
          <h3>九恒传真</h3>
          <h4>周一至周五 9:00-18:00</h4>
          <h5>（+86） 010-50856301</h5>
        </li>
        <li class="map"><a :href="url" target="_blank"><img src="@/assets/c1-3.jpg"/></a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curImg: 0,
      url: 'https://map.baidu.com/dir/%E6%88%91%E7%9A%84%E4%BD%8D%E7%BD%AE/%E5%8C%97%E4%BA%AC%E4%B9%9D%E5%B7%9E%E6%81%92%E7%9B%9B%E7%94%B5%E5%8A%9B%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12480013.081654813,4192226.0899802083,7.13z?querytype=bse&c=218&singleType=1&poiType=0&isSingle=true&ptx=12733733&pty=3564367&wd=%E5%8C%97%E4%BA%AC%E4%B9%9D%E5%B7%9E%E6%81%92%E7%9B%9B%E7%94%B5%E5%8A%9B%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&name=%E6%88%91%E7%9A%84%E4%BD%8D%E7%BD%AE&wd2=%E5%8C%97%E4%BA%AC%E5%B8%82%E5%A4%A7%E5%85%B4%E5%8C%BA&sn=1$$$$12733733,3564367$$%E6%88%91%E7%9A%84%E4%BD%8D%E7%BD%AE$$$$$$&exptype=dep&exptime=2022-09-15%2022:38&version=5&da_src=shareurl'
    }
  }
}
</script>
